import { render, staticRenderFns } from "./collection-list-item.vue?vue&type=template&id=0f253ffe&"
import script from "./collection-list-item.vue?vue&type=script&lang=ts&"
export * from "./collection-list-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports